const ClubList = require('ffss/component/row/club/List');
require('ffss/component/row/club/DepartementMap');

class ClubSearch{
    defaultOptions() {
        return {
        	'$container': null,
        	'urlDetail': '/club/detail'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onClickNext = this.onClickNext.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/ClubSearch","error");
        }


        this.$form = $('.club-search-form',this.$container);
        this.$resultContainer = $('.block-club-search__result',this.$container);
        this.$listContainer = $('.club-search-list',this.$container);
        this.$noResultContainer = $('.club-search-noresult',this.$container);
        this.$loader = $('.club-search-loader',this.$container);

        this.$headerContainer = $('.block-club-search__result--header',this.$container);
        this.$headerTitle = $('.block-club-search__result--title',this.$headerContainer);
        this.$headerDescription = $('.block-club-search__result--decs',this.$headerContainer);

		this.$filterRegion = $('select[name="region"]',this.$form);
		this.$filterDepartement = $('select[name="departement"]',this.$form);
		this.$filterType = $('select[name="type"]',this.$form);
		this.$filterSearch = $('input[name="search"]',this.$form);
		this.$filtersActivite = $('input[name="activites[]"]',this.$form);
		this.$btnSubmit = $('.btn-submit',this.$form);

        this.currentOffset = 0;
        this.currentRequest =  null;
        this.goToFirstResult = false;

        this.initialize();
    }


    initialize(){
    	var self = this;

    	this.$form.on('submit',this.onSubmit);

		this.$filterRegion.on('change',this.onFilterChange);
		this.$filterDepartement.on('change',this.onFilterChange);
		this.$filterType.on('change',this.onFilterChange);
		this.$filterSearch.on('change',this.onFilterChange);
		this.$filtersActivite.on('change',this.onFilterChange);
		this.$btnSubmit.on('click',this.onFilterChange);

		this.list = new ClubList({
			'$container': this.$listContainer,
			'onClickNext': this.onClickNext,
			'urlDetail': this.settings.urlDetail
		});	

		this.initMap();

		this.$form.trigger('submit');
    }

    showList(){
		this.$listContainer.show();
    }

    onFilterChange(event){
    	let $filter = $(event.target);

    	let filterName = $filter.attr('name');

    	switch(filterName){
    		case 'region':
    			this.onChangeRegion();
			break;
    		case 'departement':
    			this.onChangeDepartement();
			break;
		}

    	this.currentOffset = 0;

    	if(this.canSubmit()){
    		this.$form.trigger('submit');
    	}
    }

    onChangeRegion(){
    	let idRegion = this.$filterRegion.val();

    	if(idRegion){
	    	let idDepartement = this.$filterDepartement.val();
	    	if(idDepartement){
	    		let $departement = $('option[value="'+idDepartement+'"]',this.$filterDepartement);
	    		if($departement.data('region') != idRegion){
	    			this.$filterDepartement.val("").trigger('change');
	    		}
	    	}
    		$('option',this.$filterDepartement).data('hidden',true);
    		$('option[data-region="'+idRegion+'"]',this.$filterDepartement).data('hidden',false);
    		$('option[value=""]',this.$filterDepartement).data('hidden',false);
	    }else{
	    	$('option',this.$filterDepartement).data('hidden',false);
	    }

	    this.$filterDepartement.select2('destroy');
	    this.$filterDepartement.select2({
            templateResult: function(option) {
                let $option = $(option.element);
                if($option.data('hidden')){
                    return null;
                }
                return option.text;
            }
        });
    }

    onChangeDepartement(){
    	let idDepartement = this.$filterDepartement.val();

    	if(idDepartement){

	    	let $departement = $('option[value="'+idDepartement+'"]',this.$filterDepartement);

	    	let region = $departement.data('region');

	    	this.$filterRegion.val(region).trigger('change.select2');
	    }

    }

    canSubmit(){
		let region = this.$filterRegion.val();
		let departement = this.$filterDepartement.val();
		let type = this.$filterType.val();
		let search = this.$filterSearch.val();
		let activites = [];

		this.$filtersActivite.each(function(){
			let $activiteCheckbox = $(this);
			if($activiteCheckbox.is(':checked')){
				activites.push($activiteCheckbox.val());
			}
		});

    	return true;
    }

    onSubmit(event){
		event.preventDefault();
		event.stopPropagation();

		this.doSubmit(true);

    }

    getData(){
    	let data  = this.$form.serializeArray();

    	data.push({
    		'name': 'mode',
    		'value': 'public',
    	});

    	data.push({
    		'name': 'order',
    		'value': "VilleOrga",
    	});
    	data.push({
    		'name': 'notType',
    		'value': 804,
    	});

    	data.push({
    		'name': 'start',
    		'value': this.currentOffset
    	});

    	data.push({
    		'name': 'length',
    		'value': 30,
    	});

    	return data;
    }

    doSubmit(clearList){
    	var self = this;

        
        if(this.currentRequest != null){
            this.currentRequest.abort();
        }

		this.$resultContainer.show();
		this.$loader.show();
		this.$noResultContainer.hide();

		if(clearList){
			this.$listContainer.hide();
		}
		this.list.setNeedClear(clearList);

    	let data = this.getData();

        this.currentRequest = $.ajax({
    		'url': this.$form.attr('action'),
    		'method': this.$form.attr('method'),
    		'data': data
    	})
    	.done(function(xhr){
    		if(xhr.success){
    			self.showResult(xhr);
    		}else{
    			window.notify("todo notification of error : "+ xhr.message,"error");
    		}
    	})
    	.fail(function(){
    		window.notify("todo notification of error","error");
    	})
    	.always(function(){
    		self.$loader.hide();
    	});

    }

    showResult(xhr){
    	if(xhr.data.length == 0){
    		this.$noResultContainer.show();
    	}else{
    		this.fillListWithResult(xhr);
    		this.$listContainer.show();
	    }
    }

	fillListWithResult(data){
		this.list.setData(data);
		if(this.goToFirstResult){
			this.list.goToFirstResult();
			this.goToFirstResult = false;
		}
	}

	onClickNext(offset){
		this.currentOffset = offset;

		this.doSubmit(false);
	}


	initMap(){
		var self = this;


		$('#domTom').on('click',function(){
			let $item = $(this);
			let region = $item.data('region');
			self.$filterRegion.val(region).trigger('change');
		});

		$('#francemap').vectorMap({
			'map': 'france_departements',
			'backgroundColor': '#f5f5f5',
			'borderColor': '#ffffff',
			'borderOpacity': 0.25,
			'borderWidth': 1,
			'color': '#1aa9d4',
			'enableZoom': false,
			'hoverColor': '#3BB5DA',
			'hoverOpacity': null,
			'normalizeFunction': 'linear',
			'scaleColors': ['#b6d6ff', '#005ace'],
			'selectedColor': '#3BB5DA',
			'selectedRegion': null,
			'showTooltip': true,
			'onRegionClick': function(event, code){
				self.goToFirstResult = true;
				self.$filterDepartement.val(code).trigger('change');
			}
		});
	}
}

module.exports = ClubSearch;